"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormExchange = void 0;
var react_1 = __importStar(require("react"));
var FormExchange_module_scss_1 = __importDefault(require("./FormExchange.module.scss"));
var Checkbox_1 = require("../../components/checkbox/Checkbox");
var CheckboxAgree_1 = require("../../components/checkboxAgree/CheckboxAgree");
var FieldSlider_1 = require("../../components/fieldSlider/FieldSlider");
var FormField_1 = require("../../components/formField/FormField");
var FormFieldPhone_1 = require("../../components/formFieldPhone/FormFieldPhone");
var FormSendButton_1 = require("../../components/formSendButton/FormSendButton");
var SelectAutoButton_1 = require("../../components/selectAutoButton/SelectAutoButton");
var useExchangeForm_1 = require("../../hook/useExchangeForm");
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
// Проверяем, нужна ли капча
var isCaptchaEnabled = process.env.CAPTCHA_ENABLED === 'true';
var FormExchange = function () {
    var _a;
    var _b = (0, useExchangeForm_1.useExchangeForm)(), sliderField = _b.sliderField, handleSubmit = _b.handleSubmit, onSubmit = _b.onSubmit, register = _b.register, errors = _b.errors, inCreditField = _b.inCreditField, setValue = _b.setValue, payment = _b.payment;
    var _c = (0, react_1.useState)(null), captchaToken = _c[0], setCaptchaToken = _c[1];
    var handleFormSubmit = function (data) {
        if (isCaptchaEnabled && !captchaToken) {
            alert('Пожалуйста, подтвердите, что вы не робот.');
            return;
        }
        onSubmit(__assign(__assign({}, data), { captcha_token: captchaToken }));
    };
    return (react_1.default.createElement("form", { className: FormExchange_module_scss_1.default.exchange__form, onSubmit: handleSubmit(handleFormSubmit) },
        react_1.default.createElement(SelectAutoButton_1.SelectAutoButton, { isError: Boolean(errors.car_id), register: register('car_id', {
                required: true,
                validate: function (value) { return String(value) !== 'Выбрать автомобиль'; },
            }) }),
        react_1.default.createElement(Checkbox_1.Checkbox, { register: register('trade_in_credit'), id: "trade_in_credit", textContent: "\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0432 \u043A\u0440\u0435\u0434\u0438\u0442", isError: 'no error' }),
        react_1.default.createElement("div", { className: FormExchange_module_scss_1.default.exchange__extra_fields, style: { height: inCreditField ? '100%' : '0%' } },
            react_1.default.createElement(FieldSlider_1.FieldSlider, { endpoints: sliderField.endpoints.credit_terms, initValue: 2, register: register('credit_term', { required: true }), steps: sliderField.steps.credit_terms, ticksContentWidth: 'calc(100% - 24px)', ticksLeft: "18px", titleText: "\u0421\u0440\u043E\u043A \u043A\u0440\u0435\u0434\u0438\u0442\u0430, \u043C\u0435\u0441.:", unitOfMeasurement: "\u043C\u0435\u0441.", fieldName: "credit_term", setValue: setValue }),
            react_1.default.createElement(FieldSlider_1.FieldSlider, { endpoints: sliderField.endpoints.initial_contribution, initValue: 0, register: register('initial_contribution', { required: true }), steps: sliderField.steps.initial_contribution, ticksContentWidth: 'calc(100% - 28px)', ticksLeft: "19px", titleText: "\u041F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441:", unitOfMeasurement: "\u20BD", fieldName: "initial_contribution", setValue: setValue })),
        react_1.default.createElement("h3", { className: FormExchange_module_scss_1.default.exchange__payment },
            "\u0412\u0430\u0448 \u043F\u043B\u0430\u0442\u0451\u0436: ",
            react_1.default.createElement("span", null,
                payment,
                "\u20BD")),
        react_1.default.createElement(FormField_1.FormField, { register: register('customer_car', {
                required: true,
                minLength: {
                    value: 2,
                    message: 'Минимальная длина - 2 символа.',
                },
                pattern: {
                    value: /^[a-zA-Zа-яА-ЯёЁ0-9\s-]+$/,
                    message: 'Используйте только буквы, цифры, пробел или дефис',
                },
                validate: {
                    noSpecialChars: function (value) {
                        return !/[!@#$%^&*()_+={}[\]|\\:;"'<>,.?/]/.test(value) || 'Специальные символы не допускаются';
                    },
                },
            }), id: "trade_in_your_auto", placeholder: "\u0412\u0430\u0448 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C", isError: Boolean(errors.customer_car) }),
        react_1.default.createElement(FormField_1.FormField, { register: register('name', {
                required: true,
                minLength: {
                    value: 2,
                    message: 'Минимальная длина - 2 символа.',
                },
                pattern: {
                    value: /^[a-zA-Zа-яА-ЯёЁ\s-]+$/,
                    message: 'Используйте только буквы, пробел или дефис',
                },
            }), id: "trade_in_your_name", placeholder: "\u0424\u0418\u041E", isError: Boolean(errors.name) }),
        react_1.default.createElement(FormFieldPhone_1.FormFieldPhone, { register: register, id: "trade_in_credit_phone", isError: Boolean(errors.phone) }),
        react_1.default.createElement(CheckboxAgree_1.CheckboxAgree, { register: register('agree', { required: true }), id: "trade_in_agree", isError: Boolean(errors.agree) }),
        isCaptchaEnabled && (react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: (_a = process.env.REACT_APP_RECAPTCHA_SITE_KEY) !== null && _a !== void 0 ? _a : '', onChange: function (token) { return setCaptchaToken(token); } })),
        react_1.default.createElement(FormSendButton_1.FormSendButton, { textContent: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443" })));
};
exports.FormExchange = FormExchange;
